<figure kb-figure>
  <kb-picture-lightbox #lightboxElement
    [picture]="imageToPicture(section.attributes, aspectRatio).sources"
    [alt]="section.attributes.alt"
  >
    <kb-picture [appEditorId]="section.editorIds?.src"
      [appOgImage]="section.attributes"
      [picture]="imageToPicture(section.attributes, aspectRatio).sources"
      [alt]="section.attributes.alt"
      [rootColumns]="rootColumns()"
    ></kb-picture>
  </kb-picture-lightbox>
  @if (section.attributes.caption || section.attributes.downloadUrls) {
  <figcaption>
    @if (section.attributes.caption) {
    <kb-line-clamp lines="2"
      [appEditorId]="section.editorIds?.caption"
    >{{section.attributes.caption }}</kb-line-clamp>
    }
    @if (section.attributes.downloadUrls) {
    <a class="download" kb-icon [icon]="iconDownload" icon-uppercase icon-center
      download [href]="section.attributes.downloadUrls.high" target="_blank"
      i18n-aria-label="label for the image download button@@3099741642167775297" aria-label="Download"
      i18n-title="label for the image download button@@3099741642167775297" title="Download"
    ></a>
    }
  </figcaption>
  }
</figure>
